module.exports = __webpack_public_path__ + "media/smart_sales/ss_photo_3-b17309b8.webp";